import styles from "./separator.module.css";

const Separator = ({ ...rest }) => {
  return <hr className={styles.separator} {...rest} />;
};

export default Separator;
